/**
 * "Rendering modes" — Core Concepts (ADR-0074).
 * Reconciled from product/architecture/widget-rendering.md and the widget
 * primitive registry / registerComponent runtime API.
 */
import type { DocPageContent } from '../types';

export const RENDERING_PAGE: DocPageContent = {
  slug: 'rendering',
  titleKey: 'docs.concepts.rendering.title',
  descriptionKey: 'docs.concepts.rendering.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.concepts.rendering.lead' },

    {
      kind: 'heading',
      level: 2,
      id: 'primitives',
      textKey: 'docs.concepts.rendering.primitives.heading',
    },
    { kind: 'paragraph', textKey: 'docs.concepts.rendering.primitives.body' },

    { kind: 'heading', level: 2, id: 'custom', textKey: 'docs.concepts.rendering.custom.heading' },
    { kind: 'paragraph', textKey: 'docs.concepts.rendering.custom.body' },

    {
      kind: 'heading',
      level: 2,
      id: 'navigate',
      textKey: 'docs.concepts.rendering.navigate.heading',
    },
    { kind: 'paragraph', textKey: 'docs.concepts.rendering.navigate.body' },

    { kind: 'heading', level: 2, id: 'choose', textKey: 'docs.concepts.rendering.choose.heading' },
    { kind: 'paragraph', textKey: 'docs.concepts.rendering.choose.body' },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.concepts.rendering.next.memory.title',
          textKey: 'docs.concepts.rendering.next.memory.text',
          to: { docSlug: 'memory' },
        },
        {
          titleKey: 'docs.concepts.rendering.next.reliability.title',
          textKey: 'docs.concepts.rendering.next.reliability.text',
          to: { docSlug: 'reliability' },
        },
      ],
    },
  ],
};
